<vc-dialog
    [title]="title"
    [primaryLabel]="primaryLabel"
    [secondaryLabel]="secondaryLabel"
    [(visible)]="visible"
    [closeOnPrimary]="true"
    [primaryDisabled]="!selectedOrgNode"
    (primaryTrigger)="selectOrg()"
    (secondaryTrigger)="filterValue = ''">
    @if (searchByFilter) {
        <vc-input
            class="vc-org-picker-input"
            prefixIcon="search"
            [label]="filterLabel"
            [placeholder]="filterPlaceholder"
            [showClear]="true"
            [(value)]="filterValue"
            (valueChange)="filterValueChange.emit($event)"></vc-input>
    }

    @if (loading) {
        <div class="vc-org-picker-no-orgs" [vcProgressSpinner]="loading"></div>
    } @else if (orgTreeNodes && orgTreeNodes.length > 0) {
        <vc-tree
            #orgTree
            [filterLabel]="'COMMON_UI.TREE.FILTER' | transloco"
            [filterPlaceholder]="'COMMON_UI.TREE.FILTER' | transloco"
            [showFilter]="!searchByFilter"
            style="width: 700px; overflow-y: hidden; padding: 2px; min-height: 400px"
            [(highlighted)]="selectedOrgNode"
            [data]="orgTreeNodes"
            [highlightable]="true"
            [itemRenderer]="orgItemRenderer">
            <ng-template let-node>
                <div class="vc-org-picker-node">
                    <span
                        class="vc-org-picker-node-span"
                        [matTooltip]="node.data.name"
                        [innerHTML]="
                            node.data.name ?? ''
                                | boldBySearch: filterValue ?? (orgTreeComponent && (orgTreeComponent.filter ?? ''))
                        "></span>
                    @if (showTags) {
                        <vc-chip-tags [tags]="node.data.tags" [showCount]="1" [wrap]="false"></vc-chip-tags>
                    }
                    @if (selectedOrg?.id === node.data.id) {
                        <vc-icon class="vc-highlighted-node-icon" style="padding-right: 8px" name="done"></vc-icon>
                    }
                </div>
            </ng-template>
        </vc-tree>
    } @else if (orgTreeNodes && orgTreeNodes.length === 0) {
        <div class="vc-org-picker-no-orgs body-medium">
            <span class="h2-heading">{{ 'ORG_PICKER.NO_MATCHES_FOUND' | transloco }}</span>
            <span>{{ 'ORG_PICKER.TRY_ADDING_MORE_CHARACTERS' | transloco }}</span>
        </div>
    }
</vc-dialog>
